import { render, staticRenderFns } from "./ReservationConfirmation.vue?vue&type=template&id=6b821f84&scoped=true"
import script from "./ReservationConfirmation.vue?vue&type=script&lang=js"
export * from "./ReservationConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ReservationConfirmation.vue?vue&type=style&index=0&id=6b821f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b821f84",
  null
  
)

export default component.exports